import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = { class: "o-form__item" }
const _hoisted_3 = {
  class: "o-filelabel__wrap",
  "data-filelabel": "wrap"
}
const _hoisted_4 = ["id", "name", "placeholder", "required", "accept", "autocomplete"]
const _hoisted_5 = {
  class: "o-filelabel__text",
  "data-filelabel": "text"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "o-form__validation" }
const _hoisted_10 = { class: "o-form__validation__required" }
const _hoisted_11 = { class: "o-form__validation__error" }
const _hoisted_12 = {
  key: 0,
  class: "o-form__instruction"
}
const _hoisted_13 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_inputlabel = _resolveComponent("inputlabel")
  const _component_svgIco = _resolveComponent("svgIco")

  return (!$props.disabledIDs.includes($props.field.id))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-component-name": _ctx.$options.name,
        class: _normalizeClass((!$props.field.inputClass) ? 'o-grid-12' : $props.field.inputClass)
      }, [
        _createVNode(_component_inputlabel, { field: $props.field }, null, 8 /* PROPS */, ["field"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["o-filelabel o-input__icon__wrap", { 'has-file': $data.selectedFile }])
            }, [
              _withDirectives(_createElementVNode("input", _mergeProps({
                ref: "fileInput",
                onChange: _cache[0] || (_cache[0] = (...args) => ($options.setFileValue && $options.setFileValue(...args))),
                class: ["o-input-file o-filelabel__input", { 'readonly': $props.field.inputReadonly === true }]
              }, _toHandlers($data.readOnlyHandlers, true), {
                type: "file",
                id: 'input-'+$props.field.id,
                name: $props.field.inputName,
                placeholder: $props.field.inputPlaceholder,
                required: ($props.field.inputRequired === true) ? 'required' : false,
                accept: $props.field.inputFileAllowedTypes,
                autocomplete: ($props.field.inputAutocomplete && $props.field.inputAutocomplete != '' && $props.field.inputAutocomplete != 'querystring' && $props.field.inputAutocomplete != 'reactivevalue' && $props.field.inputAutocomplete != 'cookie') ? $props.field.inputAutocomplete : false
              }), null, 16 /* FULL_PROPS */, _hoisted_4), [
                [_vShow, !$data.selectedFile]
              ]),
              _createElementVNode("span", _hoisted_5, [
                _createTextVNode(_toDisplayString($options.placeholder) + " ", 1 /* TEXT */),
                ($data.selectedFile)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "o-input__close",
                      style: {"float":"right"},
                      onClick: _cache[1] || (_cache[1] = _withModifiers($event => {$data.selectedFile=null; _ctx.$refs.fileInput.value = null}, ["stop"]))
                    }, _hoisted_8))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_svgIco, {
                  icon: "attachment",
                  class: "o-input__icon"
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx._t('Ce champ est obligatoire.')), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx._t('Ce champ est invalide.')), 1 /* TEXT */)
              ])
            ], 2 /* CLASS */)
          ])
        ]),
        ($props.field.inputInstructions && String($props.field.inputInstructions).trim() != '')
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
              _createElementVNode("small", {
                innerHTML: $props.field.inputInstructions
              }, null, 8 /* PROPS */, _hoisted_13)
            ]))
          : _createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}